import React, { Component, Fragment } from 'react';

import './style/plan.scss';
import classNames from 'classnames';

import facebook from './images/facebook.svg';
import instagram from './images/instagram.svg';
import search from './images/search.svg';

export default class Step extends Component {
	formDefaults = {
		selectCombo: {
			value: '', isValid: false, input: 'select', name: 'selectCombo', checked: false,
		},
		checkGoogleSearch: {
			value: '', isValid: false, input: 'checkbox', name: 'checkGoogleSearch', checked: false,
		},
		checkGoogleDisplay: {
			value: '', isValid: false, input: 'checkbox', name: 'checkGoogleDisplay', checked: false,
		},
		checkFacebook: {
			value: '', isValid: false, input: 'checkbox', name: 'checkFacebook', checked: false,
		},
		checkInstagram: {
			value: '', isValid: false, input: 'checkbox', name: 'checkInstagram', checked: false,
		},
		fieldFacebook: {
			value: '', isValid: true, message: '', input: 'text', name: 'facebook', checked: false,
		},
		fieldInstagram: {
			value: '', isValid: true, message: '', input: 'text', name: 'instagram', checked: false,
		},
	};

	dataStepPlan = [
		{
			typeField: 'select',
			nameField: 'selectCombo',
			options: [
				{
					label: 'COMBO I',
					value: 'COMBO I',
					optgroup: [{ label: 'COMBO I - 1 mês', value: '1 mês' }, {
						label: 'COMBO I - 2 meses',
						value: '2 meses',
					}, { label: 'COMBO I - 3 meses', value: '3 meses' }, { label: 'COMBO I - 6 meses', value: '6 meses' }],
				},
				{
					label: 'COMBO II',
					value: 'COMBO II',
					optgroup: [{ label: 'COMBO II - 1 mês', value: '1 mês' }, {
						label: 'COMBO II - 2 meses',
						value: '2 meses',
					}, { label: 'COMBO II - 3 meses', value: '3 meses' }, { label: 'COMBO II - 6 meses', value: '6 meses' }],
				},
				{
					label: 'COMBO III',
					value: 'COMBO III',
					optgroup: [{ label: 'COMBO III - 1 mês', value: '1 mês' }, {
						label: 'COMBO III - 2 meses',
						value: '2 meses',
					}, { label: 'COMBO III - 3 meses', value: '3 meses' }, { label: 'COMBO III - 6 meses', value: '6 meses' }],
				},
			],
			classField: 'form-control',
			valueField: (typeof this.formDefaults.selectCombo !== 'undefined') ? this.formDefaults.selectCombo.value : [],
		},
		{
			typeField: 'checkbox',
			nameField: 'checkGoogleSearch',
			options: [
				{
					label: 'Google Search',
					value: 'Google Search',
				},
			],
			classField: 'form-control',
			toggleVisible: true,
			valueField: (typeof this.formDefaults.checkGoogleSearch !== 'undefined') ? this.formDefaults.checkGoogleSearch.value : [],
		},
		{
			typeField: 'checkbox',
			nameField: 'checkGoogleDisplay',
			options: [
				{
					label: 'Google Display',
					value: 'Google Display',
				},
			],
			classField: 'form-control',
			toggleVisible: true,
			valueField: (typeof this.formDefaults.checkGoogleDisplay !== 'undefined') ? this.formDefaults.checkGoogleDisplay.value : [],
		},
		{
			typeField: 'checkbox',
			nameField: 'checkFacebook',
			options: [
				{ label: 'Facebook', value: 'Facebook' },
			],
			classField: 'form-control',
			toggleVisible: true,
			valueField: (typeof this.formDefaults.checkFacebook !== 'undefined') ? this.formDefaults.checkFacebook.value : [],
		},
		{
			typeField: 'checkbox',
			nameField: 'checkInstagram',
			options: [
				{ label: 'Instagram', value: 'Instagram' },
			],
			classField: 'form-control',
			toggleVisible: true,
			valueField: (typeof this.formDefaults.checkInstagram !== 'undefined') ? this.formDefaults.checkInstagram.value : [],
		},
		{
			question: 'Insira o link da FANPAGE da sua loja no Facebook:',
			typeField: 'text',
			nameField: 'fieldFacebook',
			placeholder: 'Digite o campo do facebook',
			valueField: this.formDefaults.fieldFacebook.value,
			messageErrorField: this.formDefaults.fieldFacebook.message,
			classField: 'form-control toggle-password',
			classContainer: '',
			required: true,
		},
		{
			question: 'Insira o link do perfil da sua loja no Instagram:',
			typeField: 'text',
			nameField: 'fieldInstagram',
			placeholder: 'Digite o campo do instagram',
			valueField: this.formDefaults.fieldInstagram.value,
			messageErrorField: this.formDefaults.fieldInstagram.message,
			classField: 'form-control toggle-password',
			classContainer: '',
			required: true,
		},
	];

	constructor(props) {
		super(props);

		this.state = {
			rangeGoogleSearch: 0,
			rangeGoogleDisplay: 0,
			rangeFacebook: 0,
			rangeInstagram: 0,
			totalGoogle: 0,
			total: 0,
			stepDone: false,
			nextStep: false,
			typeCombo: '',
			maxSelect: 0,
			showMessageError: false,
			messageError: '',
			...this.formDefaults,
			fieldValue: '',
			onlyGoogle: false,
		};
	}

	componentDidMount() {
		const { valueField } = this.props;

		const combo = valueField.plan.split('-');

		if (combo[0].trim() === 'Combo I') {
			return this.setState({
				onlyGoogle: true,
			}, () => this.loadValueField(valueField));
		}

		return this.loadValueField(valueField);
	}

	componentWillReceiveProps(nextProps) {
		this.loadMessageFields(nextProps.valueField);
	}

	shouldComponentUpdate(nextProps, nextState) {
		const {
			rangeGoogleSearch,
			checkGoogleSearch,
			rangeGoogleDisplay,
			checkGoogleDisplay,
			onlyGoogle,
		} = this.state;

		if ((checkGoogleSearch.checked && onlyGoogle) && (rangeGoogleSearch !== 100)) {
			checkGoogleDisplay.checked = false;

			return this.setState({
				rangeGoogleSearch: 100,
				rangeGoogleDisplay: 0,
				checkGoogleDisplay,
			}, this.buildAndSend);
		}

		if ((checkGoogleDisplay.checked && onlyGoogle) && (rangeGoogleDisplay !== 100)) {
			checkGoogleSearch.checked = false;

			return this.setState({
				rangeGoogleDisplay: 100,
				rangeGoogleSearch: 0,
				checkGoogleSearch,
			}, this.buildAndSend);
		}

		return (nextProps, nextState);
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.nextStep && !this.checkValue()) {
			this.stepLinkSocial();
		}
	}

	onChange = (e) => {
		const element = e.target;
		let value = '';
		const state = Object.assign(this.state);

		switch (element.type) {
			case 'checkbox':
				// eslint-disable-next-line no-case-declarations
				let arrayValues = [];
				// eslint-disable-next-line react/destructuring-assignment
				if (this.state[element.name]) {
					arrayValues = state[element.name];
					arrayValues.checked = !arrayValues.checked;
					arrayValues.value = arrayValues.checked ? element.value : '';
					value = arrayValues;
				}
				break;
			default:
				arrayValues = state[element.name];
				arrayValues.value = element.value;
				value = arrayValues;
		}

		this.updateRangesByCheckbox();
		this.setState({
			[element.name]: value,
		}, this.buildAndSend);
	};

	setMaxRangeValue(rangeName, value) {
		value = parseFloat(value);
		const {
			rangeGoogleDisplay,
			rangeGoogleSearch,
			rangeFacebook,
			rangeInstagram,
		} = this.state;

		const ranges = [
			{ name: 'rangeGoogleDisplay', value: parseFloat(rangeGoogleDisplay) },
			{ name: 'rangeGoogleSearch', value: parseFloat(rangeGoogleSearch) },
			{ name: 'rangeInstagram', value: parseFloat(rangeInstagram) },
			{ name: 'rangeFacebook', value: parseFloat(rangeFacebook) },
		];

		const reducer = (acc, curr) => ((curr.name !== rangeName) ? acc + curr.value : acc);
		const otherRangesVal = ranges.reduce(reducer, 0);

		return otherRangesVal + value > 100 ? 100 - otherRangesVal : value;
	}

	updateRangesByCheckbox = () => {
		const {
			rangeGoogleSearch,
			rangeGoogleDisplay,
			rangeFacebook,
			rangeInstagram,
			checkGoogleSearch,
			checkGoogleDisplay,
			checkFacebook,
			checkInstagram,
			fieldFacebook,
			fieldInstagram,
		} = this.state;

		fieldFacebook.value = checkFacebook.checked || checkInstagram.checked ? fieldFacebook.value : '';
		fieldInstagram.value = !checkInstagram.checked ? '' : fieldInstagram.value;

		this.setState({
			rangeGoogleSearch: !checkGoogleSearch.checked ? 0 : rangeGoogleSearch,
			rangeGoogleDisplay: !checkGoogleDisplay.checked ? 0 : rangeGoogleDisplay,
			rangeFacebook: !checkFacebook.checked ? 0 : rangeFacebook,
			rangeInstagram: !checkInstagram.checked ? 0 : rangeInstagram,
			fieldFacebook,
			fieldInstagram,
		});
	};

	onChangeRange = (evt) => {
		const value = this.setMaxRangeValue(evt.target.name, evt.target.value);

		this.setState({
			[evt.target.name]: parseFloat(value),
		}, this.buildAndSend);
	};

	countFieldsActive = () => {
		const {
			checkGoogleSearch,
			checkGoogleDisplay,
			checkFacebook,
			checkInstagram,
			selectCombo,
		} = this.state;

		const qtdChecked = +checkGoogleSearch.checked
			+ checkGoogleDisplay.checked
			+ checkFacebook.checked
			+ checkInstagram.checked;

		if (qtdChecked >= 3 && !selectCombo.value.match('Combo III')) {
			return qtdChecked;
		}

		if (qtdChecked >= 2 && !selectCombo.value.match('Combo III')) {
			return true;
		}

		if (qtdChecked >= 3 && selectCombo.value.match('Combo III')) {
			return true;
		}

		if (selectCombo.value === '') {
			return true;
		}

		return false;
	};

	hasGoogle = () => {
		const {
			checkGoogleSearch,
			checkGoogleDisplay,
		} = this.state;

		const qtdChecked = +checkGoogleSearch.checked
			+ checkGoogleDisplay.checked;

		return qtdChecked > 0;
	};

	checkedHasBuget = () => {
		const {
			checkGoogleSearch,
			checkGoogleDisplay,
			checkFacebook,
			checkInstagram,
			rangeFacebook,
			rangeInstagram,
			rangeGoogleSearch,
			rangeGoogleDisplay,
		} = this.state;

		return checkGoogleSearch.checked === Boolean(rangeGoogleSearch)
			&& checkGoogleDisplay.checked === Boolean(rangeGoogleDisplay)
			&& checkFacebook.checked === Boolean(rangeFacebook)
			&& checkInstagram.checked === Boolean(rangeInstagram);
	};

	checkValue = () => {
		const {
			rangeGoogleSearch,
			rangeGoogleDisplay,
			rangeFacebook,
			rangeInstagram,
		} = this.state;

		const googleRanges = rangeGoogleSearch + rangeGoogleDisplay;
		const totalRanges = googleRanges + rangeFacebook + rangeInstagram;
		const isUnderTwenty = (rangeGoogleSearch > 0 && rangeGoogleSearch < 20)
			|| (rangeGoogleDisplay > 0 && rangeGoogleDisplay < 20)
			|| (rangeFacebook > 0 && rangeFacebook < 20)
			|| (rangeInstagram > 0 && rangeInstagram < 20);

		if (!this.checkedHasBuget()) {
			return 'Todos os canais precisam ter investimento.';
		}

		if (!this.hasGoogle()) {
			return 'Você deve ter pelo menos 1 canal do google';
		}

		if ((totalRanges > 100) && (totalRanges !== 0)) {
			return 'Valor não pode utrapassar 100%.';
		}

		if ((totalRanges < 100) && (totalRanges !== 0)) {
			return 'Valor não pode ser menor que 100%.';
		}

		if ((googleRanges < 30) && (googleRanges !== 0)) {
			return 'Valor total de google não pode ser menor que 30%.';
		}

		if (isUnderTwenty) {
			return 'Os canais precisam ter no mínimo 20% de investimento.';
		}

		if (totalRanges === 100) {
			return '';
		}

		return undefined;
	};

	stepLinkSocial = () => {
		if (this.checkValue() === '') {
			this.setState({
				nextStep: true,
			});
		}
	};

	buildAndSend = () => {
		const { onGetValueField, nameField } = this.props;
		const {
			rangeGoogleSearch,
			rangeGoogleDisplay,
			rangeFacebook,
			rangeInstagram,
			fieldFacebook,
			fieldInstagram,
			selectCombo,
		} = this.state;
		const message = this.checkValue();
		const finalValues = {
			plan: selectCombo.value,
			googleSearch: {
				percent: `${rangeGoogleSearch}%`,
			},
			googleDisplay: {
				percent: `${rangeGoogleDisplay}%`,
			},
			facebook: {
				percent: `${rangeFacebook}%`,
				link: fieldFacebook.value,
			},
			instagram: {
				percent: `${rangeInstagram}%`,
				link: fieldInstagram.value,
			},
			isValidPlan: message === '',
		};

		onGetValueField(nameField, finalValues);

		this.setState({
			fieldValue: finalValues,
		}, () => {
			onGetValueField(nameField, finalValues);
		});

		return true;
	};

	loadValueField = (valueField) => {
		const channels = ['facebook', 'instagram', 'googleSearch', 'googleDisplay'];
		const googleChannels = ['googleSearch', 'googleDisplay'];
		const state = Object.assign(this.state);

		let totalPercent = 0;
		let totalGooglePercent = 0;

		for (const channel in valueField) {
			if (channel) {
				if (channels.indexOf(channel) !== -1) {
					const percent = parseFloat(valueField[channel].percent);
					const channelCap = channel.charAt(0).toUpperCase() + channel.slice(1);
					const hasLink = typeof valueField[channel].link !== 'undefined';

					state[`check${channelCap}`] = { checked: percent > 0 };
					state[`range${channelCap}`] = percent;

					if (hasLink) {
						state[`field${channelCap}`] = {
							value: valueField[channel].link,
							name: channelCap,
						};
					}

					totalPercent += percent;
					if (googleChannels.indexOf(channel) !== -1) {
						totalGooglePercent += percent;
					}
				}
			}
		}

		state.selectCombo.value = valueField.plan;
		state.totalPercent = totalPercent;
		state.totalGooglePercent = totalGooglePercent;
		this.setState(state);
		this.checkDetailsPlan(valueField.plan);
	};

	loadMessageFields = (valueField) => {
		const { fieldFacebook, fieldInstagram } = this.state;
		fieldFacebook.message = valueField.facebook.message;
		fieldInstagram.message = valueField.instagram.message;
		this.setState({
			messageError: valueField.message,
		});
	};

	renderCheckboxOptions = props => props.options.map(
		(option, index) => (
			<div key={`checkbox-option-${props.nameField}`} className="form-check">
				<label className="form-check-label" htmlFor={props.nameField + index}>
					<input
						className="form-check-input css-checkbox"
						type="checkbox"
						value={option.value}
						id={props.nameField + index}
						name={props.nameField}
						onChange={this.onChange}
						checked={Object.assign(this.state)[props.nameField].checked}
					/>
					<i />
					{option.label}
					{
						(typeof option.image !== 'undefined')
							? (
								<div className="checkbox-image">
									<img src={option.image} alt={props.label} />
								</div>
							)
							: ''
					}
				</label>
			</div>
		),
	);

	renderCheckboxInput = props => (
		<div className="check-container">
			{this.renderCheckboxOptions(props)}
		</div>
	);

	checkDetailsPlan = (details) => {
		const data = details.split('-');
		const valueCombo = data[0].toUpperCase();

		const valuePeriodo = data[1] ? data[1].toUpperCase() : '';
		let valueCanais = '';

		if (valueCombo.replace(/ /g, '') === 'COMBOII') {
			valueCanais = 'ATÉ 2 CANAIS';
		}

		if (valueCombo.replace(/ /g, '') === 'COMBOIII') {
			valueCanais = 'ATÉ 3 CANAIS';
		}

		return this.setState({
			detailsPan: { combo: valueCombo, periodo: valuePeriodo, canais: valueCanais },
		});
	};

	render() {
		const {
			rangeGoogleSearch,
			rangeGoogleDisplay,
			rangeFacebook,
			rangeInstagram,
			fieldFacebook,
			fieldInstagram,
			selectCombo,
			checkGoogleSearch,
			checkGoogleDisplay,
			checkFacebook,
			checkInstagram,
			detailsPan,
			messageError,
			onlyGoogle,
		} = this.state;

		const totalGoogleRanges = rangeGoogleSearch + rangeGoogleDisplay;
		const totalRanges = totalGoogleRanges + rangeInstagram + rangeFacebook;

		const dataStepPlan = this.dataStepPlan;
		dataStepPlan[5].classContainer = classNames('form-group', { 'has-error': !fieldFacebook.isValid });
		dataStepPlan[6].classContainer = classNames('form-group', { 'has-error': !fieldInstagram.isValid });

		return (
			<Fragment>
				<div className="step-plan">
					<div className="box-plan">
						<div className="box-plan-container">
							<div className="box-plan-content spacing-top">
								<p className="title-question">Detalhes do produto</p>
								<div className="box-details">
									<p className="m-0">Combo: <strong>{detailsPan ? detailsPan.combo : ''}</strong></p>
									<p className="m-0">Período: <strong>{detailsPan ? detailsPan.periodo : ''}</strong></p>
									{
										detailsPan && detailsPan.canais ? (
											<p className="m-0">Canais: <strong>{detailsPan.canais}</strong></p>
										) : ''
									}
								</div>
							</div>

							{selectCombo.value ? (
								<div>
									<div className="box-plan-content mt-4">
										<p className="title-question">Selecione os canais em que deseja investir:</p>
										<ul>
											<li>
												<p className="google-title">Google</p>
												<img
													src={search}
													alt="ícone do navegador google chrome."
													title="ícone do navegador google chrome."
													width="30"
													height="30"
												/>
											</li>

											<li className={(this.countFieldsActive(checkGoogleSearch.value)
												&& !checkGoogleSearch.checked) ? 'disable-field' : 'spacing-none'}
											>
												{this.renderCheckboxInput(dataStepPlan[1])}
											</li>

											<li className={(this.countFieldsActive(checkGoogleDisplay.value)
												&& !checkGoogleDisplay.checked) ? 'disable-field' : ''}
											>
												{this.renderCheckboxInput(dataStepPlan[2])}
											</li>
										</ul>

										{
											(onlyGoogle && !checkGoogleSearch.checked && !checkGoogleDisplay.checked) ? (
												<div className="help-block">
													<span className="d-block pt-2">Ops! É necessário preencher os campos acima.</span>
												</div>
											) : null
										}

										{
											onlyGoogle ? null : (
												<Fragment>
													<ul>
														<li className={(this.countFieldsActive(checkFacebook.value)
															&& !checkFacebook.checked) ? 'disable-field' : ''}
														>
															{this.renderCheckboxInput(dataStepPlan[3])}

															<img src={facebook} alt="Ícone facebook" width="30" height="30" />
														</li>
													</ul>

													<ul>
														<li className={(this.countFieldsActive(checkInstagram.value)
															&& !checkInstagram.checked) ? 'disable-field' : ''}
														>
															{this.renderCheckboxInput(dataStepPlan[4])}

															<img src={instagram} alt="Ícone Instagram" width="30" height="30" />
														</li>
													</ul>
												</Fragment>
											)
										}
									</div>

									<hr />
								</div>
							) : ''}

							{
								!onlyGoogle ? (
									<div className="box-plan-content spacing-bottom">
										{(checkGoogleSearch.checked
											|| checkGoogleDisplay.checked
											|| checkFacebook.checked) ? (
												<p className="title-question">
													Escolha o percentual de investimento
													que deseja para cada canal: <br />
													(*Lembre-se, o Google deve ter pelo
													menos, 30% de investimento)
												</p>
											) : ''}

										<div className="container-channels">
											{/* eslint-disable-next-line max-len */}
											{(checkGoogleSearch.checked || checkGoogleDisplay.checked) ? (
												<p className="mb-3">Google: <b>{`${totalGoogleRanges} %`}</b>
												</p>
											) : ''}

											<div className="container-input-range">
												{(checkGoogleSearch.checked) ? (
													<div>
														<p>Google Search: <b>{`${rangeGoogleSearch} %`}</b></p>
														<input
															type="range"
															min="0"
															max="100"
															id="range-google-search"
															value={rangeGoogleSearch}
															name="rangeGoogleSearch"
															onChange={this.onChangeRange}
														/>
													</div>
												) : ''}

												{(checkGoogleDisplay.checked) ? (
													<div>
														<p>Google display: <b>{`${rangeGoogleDisplay} %`}</b></p>
														<input
															type="range"
															min="0"
															max="100"
															id="range-google-display"
															value={rangeGoogleDisplay}
															name="rangeGoogleDisplay"
															onChange={this.onChangeRange}
															className="range-red"
														/>
													</div>
												) : ''}
											</div>

											{(checkFacebook.checked) ? (
												<div>
													<p>Facebook: <b>{`${rangeFacebook} %`}</b></p>
													<input
														type="range"
														min="0"
														max="100"
														id="range-facebook"
														value={rangeFacebook}
														name="rangeFacebook"
														onChange={this.onChangeRange}
														className="range-blue"
													/>
												</div>
											) : ''}

											{(checkInstagram.checked) ? (
												<div>
													<p>Instagram: <b>{`${rangeInstagram} %`}</b></p>
													<input
														type="range"
														min="0"
														max="100"
														id="range-instagram"
														value={rangeInstagram}
														name="rangeInstagram"
														onChange={this.onChangeRange}
														className="range-pink"
													/>
												</div>
											) : ''}
										</div>

										{(checkGoogleSearch.checked
											|| checkGoogleDisplay.checked
											|| checkFacebook.checked) ? (
												<div>
													<p className="description-bar mt-5 text-center">PERCENTUAL DE INVESTIMENTO
														TOTAL: <b>{`${totalRanges} %`}</b>
													</p>
												</div>
											) : ''}
										<p className="mt-3 message-error">{this.checkValue()}</p>
									</div>
								) : null
							}
						</div>
					</div>
				</div>
				{(rangeFacebook !== 0) || (rangeInstagram !== 0)
					? (
						<div className="component-social-plano-contratado">
							<h3>{`Você selecionou a rede social: ${checkInstagram.checked ? 'Instagram' : ''} ${checkInstagram.checked && checkFacebook.checked ? 'e' : ''} ${checkFacebook.checked ? 'Facebook' : ''}`}</h3>

							<div className="box-content box-shadow-none mb-3">
								<p>
									Para a realização da sua campanha em redes sociais é necessário que você valide
									o Termo de aceite. <br />Em breve você receberá um e-mail com as instruções.
									Para saber mais: &nbsp;
									<a
										href="http://midias.webmotors.com.br/termodeaceite"
										target="_blank"
										rel="noopener noreferrer"
										className="text-dark underlined"
									>
										Clique aqui!
									</a>
								</p>
							</div>

							<ul>
								{(checkFacebook.checked || checkInstagram.checked) ? (
									<li className="box-content">
										<h4>{dataStepPlan[5].question}</h4>
										{dataStepPlan[5].required
											? <span className="required">*Campos de preenchimento obrigatório.</span> : ''}

										<div className="row-input">
											<img src={facebook} alt="Ícone facebook" title="Ícone facebook" width={35} height={35} />
											<input
												type={dataStepPlan[5].typeField}
												name={dataStepPlan[5].nameField}
												className={dataStepPlan[5].classField}
												placeholder={dataStepPlan[5].placeholder}
												value={fieldFacebook.value}
												onChange={this.onChange}
											/>
										</div>
										<div className="help-block">{fieldFacebook.message}</div>
									</li>
								) : 'FACE'}

								{(checkInstagram.checked) ? (
									<li className="box-content">
										<h4>{dataStepPlan[6].question}</h4>
										{dataStepPlan[6].required
											? <span className="required">*Campos de preenchimento obrigatório.</span> : ''}

										<div className="row-input">
											<img src={instagram} alt="Ícone instagram" title="Ícone instagram" width={35} height={35} />
											<input
												type={dataStepPlan[6].typeField}
												name={dataStepPlan[6].nameField}
												className={dataStepPlan[6].classField}
												placeholder={dataStepPlan[6].placeholder}
												value={fieldInstagram.value}
												onChange={this.onChange}
											/>
										</div>
										<div className="help-block">{fieldInstagram.message}</div>
									</li>
								) : ''}
							</ul>
						</div>
					) : ''}

				<div className="help-block">{messageError}</div>
			</Fragment>
		);
	}
}
